import { Context, Plugin } from '@nuxt/types';

export enum UserEvent {
  /*
    Keyword events

    The "Keyword event -" prefix is required in order for the event to be matched as a
    'Keyword event' on GTM. The full string value (e.g. "Keyword event - New") is also
    passed through to Google Analytics as the event's 'Action'.
  */
  NewKeyword = 'KeywordEvent - New',
  EditKeyword = 'KeywordEvent - Edit',
  CreateKeyword = 'KeywordEvent - Create',
  UpdateKeyword = 'KeywordEvent - Update',
  DeleteKeyword = 'KeywordEvent - Delete',
  ToggleKeyword = 'KeywordEvent - Toggle',
  DownloadKeywordQRCode = 'KeywordEvent - Download QR code',
  CopyKeywordLink = 'KeywordEvent - Copy link',
  ClickKeywordSocialFacebook = 'KeywordEvent - Click social - Facebook',
  ClickKeywordSocialTwitter = 'KeywordEvent - Click social - Twitter',
  ClickKeywordSocialLinkedIn = 'KeywordEvent - Click social - LinkedIn',
  OnboardingCustomerCareNumber = 'Onboarding - Step 1 Completed - Customer Care Number',
  OnboardingFirstContact = 'Onboarding - Step 2 Completed - First Contact',
  OnboardingOptInViaSms = 'Onboarding - Step 3 Completed - Opt-in via SMS',
  ConvertedToPaying = 'Conversion - Paying user'
}

const userEvents: Plugin = (context: Context, inject) => {
  inject('userEvents', {
    track: (event: UserEvent) => {
      track(event, context);
    }
  });
};

function track(event: UserEvent, context: Context) {
  context.app.$gtm.push({ event });
}

export default userEvents;
